/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAccountBalanceIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-account-balance"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.95 15.88L3.95 11.93Q3.95 11.38 4.34 10.99Q4.72 10.6 5.28 10.6Q5.83 10.6 6.21 10.99Q6.6 11.38 6.6 11.93L6.6 15.88Q6.6 16.43 6.21 16.81Q5.83 17.2 5.28 17.2Q4.72 17.2 4.34 16.81Q3.95 16.43 3.95 15.88ZM10.65 15.88L10.65 11.93Q10.65 11.38 11.04 10.99Q11.43 10.6 11.97 10.6Q12.53 10.6 12.91 10.99Q13.3 11.38 13.3 11.93L13.3 15.88Q13.3 16.43 12.91 16.81Q12.53 17.2 11.97 17.2Q11.43 17.2 11.04 16.81Q10.65 16.43 10.65 15.88ZM2.17 21.85Q1.63 21.85 1.24 21.46Q0.85 21.07 0.85 20.52Q0.85 19.98 1.24 19.59Q1.63 19.2 2.17 19.2L21.82 19.2Q22.38 19.2 22.76 19.59Q23.15 19.98 23.15 20.52Q23.15 21.07 22.76 21.46Q22.38 21.85 21.82 21.85ZM17.4 15.88L17.4 11.93Q17.4 11.38 17.79 10.99Q18.18 10.6 18.73 10.6Q19.27 10.6 19.66 10.99Q20.05 11.38 20.05 11.93L20.05 15.88Q20.05 16.43 19.66 16.81Q19.27 17.2 18.73 17.2Q18.18 17.2 17.79 16.81Q17.4 16.43 17.4 15.88ZM21.77 8.6L2.08 8.6Q1.57 8.6 1.21 8.24Q0.85 7.88 0.85 7.38L0.85 6.6Q0.85 6.25 1.04 5.95Q1.23 5.65 1.52 5.5L10.8 0.78Q11.38 0.5 12 0.5Q12.63 0.5 13.2 0.78L22.4 5.47Q22.75 5.65 22.95 5.97Q23.15 6.3 23.15 6.7L23.15 7.22Q23.15 7.8 22.75 8.2Q22.35 8.6 21.77 8.6Z" fill={color} />
    </svg>
  );
}
